import React, { useEffect, useState } from 'react'
import UserLayout from '../../components/layouts/UserLayout'
import TextField from '../../components/elements/form/TextField'
import { useDispatch } from 'react-redux'
import PasswordField from '../../components/elements/form/PasswordField'
import ModalDialog from '../../components/layouts/ModalDialog'
import ChangePassword from '../../components/partials/ChangePassword'
import axios from 'axios'
import { authHeader } from '../../utils'
import { ERROR } from '../../store/types'
import InlinePreloader from '../../components/elements/InlinePreloader'

const UserProfile = () => {
    const dispatch = useDispatch()
    const [userDetails, setUserDetails] = useState({});
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const headers = authHeader()
        const fetchUserProfile = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/user/profile?expand=parentProfile`, { headers })  
                setUserDetails(response.data.data)
                setLoading(false)

    
            } catch (error) {
                console.log(error)
                dispatch({
                    type: ERROR,
                    error
                })
            }
        }

        fetchUserProfile()
        
        return () => {
            
        };
    }, [dispatch]);

    const [changingPassword, setChangingPassword] = useState(false);

    return (
        <>
            <UserLayout>
                {loading ? 
                    <div className='mx-auto w-max'>
                        <InlinePreloader />
                    </div>
                    :
                    <>
                        <div className='w-full lg:w-1/2 xl:w-1/3 mx-auto py-2 gap-x-12'>
                            <div className='w-full mb-8'>
                                <h3 className='font-thin text-lg'>Profile Information</h3>
                                <p className=''>Your basic profile information</p>    
                            </div>

                            <div className='w-full'>
                                {/* <p className='font-medium mb-5'>Profile Information</p> */}
                                <div className='w-full'>
                                    <div className='mt-1 mb-1 w-full'>
                                        <TextField 
                                            inputType="text" 
                                            fieldId="firstName"
                                            inputLabel="First Name" 
                                            hasError={false} 
                                            disabled={true}
                                            preloadValue={userDetails.parentProfile.firstName || ''}
                                            returnFieldValue={(value)=>{setUserDetails('firstName', value)}}
                                        />
                                    </div>
                                    <div className='mt-1 mb-1 w-full'>
                                        <TextField 
                                            inputType="text" 
                                            fieldId="lastName"
                                            inputLabel="Last Name" 
                                            hasError={false} 
                                            disabled={true}
                                            preloadValue={userDetails.parentProfile.lastName || ''}
                                            returnFieldValue={(value)=>{setUserDetails('lastName', value)}}
                                        />
                                    </div>
                                    <div className='mt-1 mb-1 w-full'>
                                        <TextField 
                                            inputType="email" 
                                            fieldId="email"
                                            inputLabel="Email Address" 
                                            hasError={false} 
                                            preloadValue={userDetails.email || ''}
                                            disabled={true}
                                            returnFieldValue={(value)=>{setUserDetails('lastName', value)}}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className='w-full lg:w-1/2 xl:w-1/3 mx-auto py-2 gap-x-12'>
                            <div className='w-full mb-8'>
                                <h3 className='font-thin font-tomato text-lg'>Security</h3>
                                <p className=''>Here are details of your account security and options to further secure your account</p>    
                            </div>

                            <div className='w-full'>
                                {/* <p className='font-medium mb-8'>Security</p> */}
                                    <div className='w-full'>
                                        <PasswordField 
                                            inputType="password" 
                                            fieldId="password"
                                            inputLabel="Password" 
                                            hidePasswordToggler={true}
                                            hasError={false} 
                                            preloadValue={'SecurePassword'}
                                            disabled={true}
                                            hideVisibilityToggler={true}
                                            // includeButton={true}
                                            // buttonLabel="Change"
                                            // buttonAction={()=>{setChangePassword(true)}}
                                            returnFieldValue={()=>{}}
                                        />
                                    </div>
                                    <button onClick={()=>{setChangingPassword(true)}} className='w-max bg-black px-6 py-3 text-white rounded-md text-sm font-[500] mt-[10px]'>
                                        Update Password
                                    </button>
                                </div>
                                
                        </div>
                    </>
                }

            </UserLayout>

            <ModalDialog
                shown={changingPassword} 
                closeFunction={()=>{setChangingPassword(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Change your password`}
                maxWidthClass='max-w-lg'
                hideActions={true}
            >
                <ChangePassword />
            </ModalDialog>
        </>
    )
}

export default UserProfile